export const LIQUID_FUND_TYPE = 1
export const ILLIQUID_FUND_TYPE = 2
